import { BlockTypeEnum } from './blockType'

export const isAgentAssessmentBlockType = (type: string | null): type is AgentAssessmentBlockType =>
  AGENT_ASSESSMENT_BLOCK_TYPES.some((agentAssessmentType) => agentAssessmentType === type)

export type AgentAssessmentBlockType = (typeof AGENT_ASSESSMENT_BLOCK_TYPES)[number]

const AGENT_ASSESSMENT_BLOCK_TYPES = [BlockTypeEnum.INHERENT_RISK_ASSESSMENT, BlockTypeEnum.RISK_CONTROLS_AGENT] as const
